import React, { useState, useEffect } from "react";
import Card from "components/card/Card.js";
import DownTimeListTable from "components/table/downTimeListTable";
import LoadingForm from "components/loader/LoadingForm";
import noGroupImage from "assets/img/layout/noGroup.png";
import {
  Box,
  Button,
  Tooltip,
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import useUserList from "hooks/user/useUserList";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import AddPermissionGroupForm from "./addPermissionGroupForm";
import EditPermissionGroup from "./editPermissionGroup";
import useDeleteGroupPermission from "hooks/groupPermissions/useDeleteGroupPermission";
import DeleteModal from "components/modal/deleteModal";
import useGetRoles from "hooks/roles/useGetRoles";
import useClientList from "hooks/useClientList";
import { getDashboardPermissions } from "Permissions";
import { useHistory } from "react-router";
import useGetPermissionGroup from "hooks/groupPermissions/useGroupPermission";

const PermissionGroup = () => {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const [editData, setEditData] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();
  const {
    isLoading,
    error,
    data: userData,
    refetch,
    isFetching,
  } = useGetPermissionGroup(20, currentPage);
  const {
    isLoading: roleLoading,
    error: roleError,
    data: roleData,
  } = useGetRoles();
  const {
    isLoading: clinetLoading,
    error: clientError,
    data: clientData,
  } = useClientList();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [deleteId, setDeleteId] = useState(null);
  const { mutate: deleteGroupPermission } = useDeleteGroupPermission(onClose);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [showAddForm, showEditForm]);

  useEffect(() => {
    refetch();
  }, [currentPage]);
  if (isLoading || isFetching) return <LoadingForm />;
  //   if (error) return null;

  const handleDelete = (id) => {
    setDeleteId(id);
    onOpen();
  };
  const handleEdit = (row) => {
    setEditData(row);
    setShowEditForm(true);
    history.push(`/admin/permission-group/edit/${row.id}`);
  };

  const columnsData = [
    {
      Header: "ID",
      accessor: (row) => {
        return (
          <Text
            color={"ndmsColors.purple.200"}
            fontSize="12px"
            fontWeight="700"
          >
            {row.id}
          </Text>
        );
      },
    },
    {
      Header: "NAME",
      accessor: (row) => {
        return (
          <Text color={"ndmsColors.blue.100"} fontSize="12px" fontWeight="700">
            {row.name}
          </Text>
        );
      },
    },
    {
      Header: "SLUG",
      accessor: (row) => {
        return (
          <Text color={"ndmsColors.blue.100"} fontSize="12px" fontWeight="700">
            {row.slug}
          </Text>
        );
      },
    },
    {
      Header: "   ",
      accessor: "   ",
    },
    {
      Header: "   ",
      accessor: "------",
    },
    {
      Header: "   ",
      accessor: "=======",
    },
    {
      Header: "   ",
      accessor: "++++++++++",
    },
    {
      Header: "ACTION",
      accessor: (row) => {
        return (
          <Flex justifyContent="center" align="center">
            {getDashboardPermissions("permissions.group.update") ? (
              <Tooltip hasArrow label="Edit" bg="#2B3674">
                <Flex mr="10px" onClick={() => handleEdit(row)}>
                  <Icon
                    as={EditIcon}
                    width="17px"
                    height="17px"
                    color="ndmsColors.purple.200"
                  />{" "}
                </Flex>
              </Tooltip>
            ) : null}
            {getDashboardPermissions("permissions.group.delete") ? (
              <Tooltip hasArrow label="Delete" bg="ndmsColors.red.200">
                <Flex onClick={() => handleDelete(row.id)}>
                  <Icon
                    as={DeleteIcon}
                    width="17px"
                    height="17px"
                    color="ndmsColors.red.200"
                  />{" "}
                </Flex>
              </Tooltip>
            ) : null}
          </Flex>
        );
      },
    },
  ];

  const handleAdd = () => {
    history.push(`/admin/permission-group/add`);
    setShowAddForm(true);
  };

  return (
    <>
      {showAddForm && (
        <AddPermissionGroupForm setShowAddForm={setShowAddForm} />
      )}
      {showEditForm && (
        <EditPermissionGroup
          setShowEditForm={setShowEditForm}
          editData={editData}
        />
      )}
      {!showAddForm && !showEditForm && (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
          <Flex align="center" justifyContent="flex-end">
            {getDashboardPermissions("permissions.group.create") ? (
              <Button
                bg="ndmsColors.purple.200"
                minWidth="104px"
                borderRadius="6px"
                mb="42px"
                _hover={{ bg: "ndmsColors.blue.400" }}
                _active={{ bg: "ndmsColors.blue.400" }}
                onClick={handleAdd}
              >
                <Icon as={AddIcon} w={3} h={3} color="#FFF" />
                <Text ml="10px" color="#FFF" fontSize="14px">
                  {" "}
                  Add
                </Text>
              </Button>
            ) : null}
          </Flex>
          <Card
            direction="column"
            w="100%"
            px="0px"
            overflowX={{ sm: "scroll", lg: "hidden" }}
          >
            {userData?.data[0]?.result?.length > 0 ? (
              <Flex p="20px" direction="column">
                <DownTimeListTable
                  tableData={userData?.data[0]?.result}
                  columnsData={columnsData}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPage={userData?.data[0]?.total_pages}
                />
              </Flex>
            ) : (
              <Flex
                align="center"
                justify="center"
                mt="200px"
                cursor="pointer"
                mb="150px"
                onClick={handleAdd}
              >
                <Flex direction="column" justify="center" align="center">
                  <Image src={noGroupImage} width="70px" alt="no-group" />
                  <Text fontSize={"22px"} color="#2B3674" fontWeight="bold">
                    You Don’t Have Any Permission Group added
                  </Text>
                </Flex>
              </Flex>
            )}
          </Card>
        </Box>
      )}
      <DeleteModal
        onOpen={onOpen}
        onClose={onClose}
        isOpen={isOpen}
        id={deleteId}
        deleteItem={deleteGroupPermission}
      />
    </>
  );
};

export default PermissionGroup;
